import React ,{useState , useRef} from "react";
import TableRows from "./TableRow";
import TableRows_new from "./TableRow_new";
function AddDeleteTableRows({ itemName , ply , Mrp, calculationtype ,GroupMaster, data , add , edit , deleter , plyquantity, TaxName, CustomerId, Code,UnitMaster,GodownMaster,ItemMaster}){


    return (
      <div className="table-responsive">
        <table className="" style={{ 
          padding: "0", 
          marginBottom: "10px",
          borderCollapse: "collapse",
          width: "100%" 
        }}>
          <thead>
            <tr>
              <th style={{
                border: "1.5px solid black",
                padding: "8px",
                backgroundColor: "#f2f2f2",
                fontWeight: "bold"
              }}>Sr.</th>
              <th style={{
                border: "1.5px solid black",
                padding: "8px",
                backgroundColor: "#f2f2f2",
                fontWeight: "bold"
              }}>Code No.</th>
              <th style={{
                border: "1.5px solid black",
                padding: "8px",
                backgroundColor: "#f2f2f2",
                fontWeight: "bold"
              }}>Godown</th>
              {/* <th style={{
                border: "1.5px solid black",
                padding: "8px",
                backgroundColor: "#f2f2f2",
                fontWeight: "bold"
              }}>Group Name</th> */}
              <th style={{
                border: "1.5px solid black",
                padding: "8px",
                backgroundColor: "#f2f2f2",
                fontWeight: "bold"
              }}>Item Name</th>
              <th style={{
                border: "1.5px solid black",
                padding: "8px",
                backgroundColor: "#f2f2f2",
                fontWeight: "bold"
              }}>Color</th>
              <th style={{
                border: "1.5px solid black",
                padding: "8px",
                backgroundColor: "#f2f2f2",
                fontWeight: "bold"
              }}>Unit</th>
              <th style={{
                border: "1.5px solid black",
                padding: "8px",
                backgroundColor: "#f2f2f2",
                fontWeight: "bold"
              }}>Avail</th>
              <th style={{
                border: "1.5px solid black",
                padding: "8px",
                backgroundColor: "#f2f2f2",
                fontWeight: "bold"
              }}>Qty</th>
              <th style={{
                border: "1.5px solid black",
                padding: "8px",
                backgroundColor: "#f2f2f2",
                fontWeight: "bold"
              }}>Rate</th>
              <th style={{
                border: "1.5px solid black",
                padding: "8px",
                backgroundColor: "#f2f2f2",
                fontWeight: "bold"
              }}>Disc</th>
              <th style={{
                border: "1.5px solid black",
                padding: "8px",
                backgroundColor: "#f2f2f2",
                fontWeight: "bold"
              }}>Amount</th>
              {/* <th style={{
                border: "1.5px solid black",
                padding: "8px",
                backgroundColor: "#f2f2f2",
                fontWeight: "bold"
              }}>Tax</th> */}
              <th style={{
                border: "1.5px solid black",
                padding: "8px",
                backgroundColor: "#f2f2f2",
                fontWeight: "bold"
              }}>Del</th>
              <th style={{
                border: "1.5px solid black",
                padding: "8px",
                backgroundColor: "#f2f2f2",
                fontWeight: "bold"
              }}>Add</th>
            </tr>
          </thead>
          <tbody>
            <TableRows_new
              rowsData={data}
              deleteTableRows={deleter}
              handleChange={edit}
              addTableRows={add}
              itemName= {itemName}
              GroupMaster={GroupMaster}
              UnitMaster={UnitMaster}
              GodownMaster={GodownMaster}
              ItemMaster={ItemMaster}
              Code={Code}
              tableStyle={{
                td: {
                  border: "1.5px solid black",
                  padding: "8px",
                  textAlign: "center"
                },
                tr: {
                  '&:hover': {
                    backgroundColor: "#f5f5f5"
                  }
                }
              }}
            />
          </tbody>
        </table>
      </div>
    );
}
export default AddDeleteTableRows